import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Contact API
export const contactAPI = {
  submit: async (data) => {
    const response = await api.post('/contact', data);
    return response.data;
  },
};

// Auth API
export const authAPI = {
  login: async (password) => {
    const response = await api.post('/auth/login', { password });
    return response.data;
  },
};

// Publications API
export const publicationsAPI = {
  getAll: async () => {
    const response = await api.get('/publications');
    return response.data;
  },

  upload: async (title, pdfFile, thumbnailFile) => {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('file', pdfFile);
    if (thumbnailFile) {
      formData.append('thumbnail', thumbnailFile);
    }

    const token = sessionStorage.getItem('adminToken');
    const response = await axios.post(`${API_BASE}/publications/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/publications/${id}`);
    return response.data;
  },
};

// Analytics API
export const analyticsAPI = {
  trackVisit: async (page) => {
    try {
      await api.post('/analytics/track', { page });
    } catch (e) { /* silent fail - don't disrupt user experience */ }
  },
  trackEvent: async (type, detail) => {
    try {
      await api.post('/analytics/event', { type, detail });
    } catch (e) { /* silent fail */ }
  },
  getSummary: async () => {
    const response = await api.get('/analytics/summary');
    return response.data;
  },
};

export default api;
